import { useEffect, useRef, type RefObject } from "react"
import { findHotspotsByItemNumber } from "../utils"

const SELECTED_CLASS = "hotspot--selected"

export const useHotspotHighlight = (
	containerRef: RefObject<HTMLElement | null>,
	selectedPartIndex: string
) => {
	const previousPartIndexRef = useRef<string>("")

	useEffect(() => {
		const container = containerRef.current
		if (!container) return

		const previousPartIndex = previousPartIndexRef.current
		if (previousPartIndex) {
			findHotspotsByItemNumber(container, previousPartIndex).forEach((el) =>
				el.classList.remove(SELECTED_CLASS)
			)
		}

		if (selectedPartIndex) {
			findHotspotsByItemNumber(container, selectedPartIndex).forEach((el) =>
				el.classList.add(SELECTED_CLASS)
			)
		}

		previousPartIndexRef.current = selectedPartIndex
	}, [containerRef, selectedPartIndex])
}
